import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const isNodeSelected = TiptapContentResolver.create((_, __, editor) => {
  const node = editor?.state?.selection?.node;
  return !!node;
});
export {
  isNodeSelected
};
//# sourceMappingURL=is-node-selected.js.map
